export const GET_LIST_DEVICES = 'GET_LIST_DEVICES'
export const GET_LIST_DEVICES_ERR = 'GET_LIST_DEVICES_ERR'

export const REQUEST_PAYMENT = 'REQUEST_PAYMENT'
export const REQUEST_PAYMENT_ERR = 'REQUEST_PAYMENT_ERR'

export const RESET_LIST_DEVICES = 'RESET_LIST_DEVICES'